import { Check } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import PayButton from '../PayButton';
import { PLANS } from '../../data/content';
import { PLAN_LINKS, PAYMENT_PAGE } from '../../data/config';

const Plans = () => (
  <section className="bg-mist py-24 md:py-32" data-testid="plans-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        index="07"
        overline="Plans"
        title="Choose the Support You Need"
        description="Simple, focused options — from a single clarity session to long-term personalised guidance."
      />

      <div className="mt-16 grid gap-6 lg:grid-cols-3">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.name} delay={0.1 * i} className="h-full">
            <div
              className={`relative flex h-full flex-col rounded-3xl border p-8 transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 md:p-10 ${
                plan.featured
                  ? 'border-coral bg-navy text-white shadow-card-hover'
                  : 'border-line bg-white shadow-card hover:shadow-card-hover'
              }`}
              data-testid={`plan-card-${plan.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {plan.featured && (
                <span className="absolute -top-3.5 left-8 rounded-full bg-coral px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white">
                  Most Chosen
                </span>
              )}
              <h3 className={`font-display text-2xl font-semibold ${plan.featured ? 'text-white' : 'text-navy'}`}>{plan.name}</h3>
              <p className={`mt-2 text-sm ${plan.featured ? 'text-white/70' : 'text-slate-500'}`}>{plan.for}</p>
              <p className={`mt-6 font-display text-4xl font-extrabold tracking-tight ${plan.featured ? 'text-coral' : 'text-navy'}`}>
                {PLAN_LINKS[plan.id].price}
              </p>
              <ul className="mt-8 flex-1 space-y-3">
                {plan.includes.map((item) => (
                  <li key={item} className={`flex items-start gap-3 text-sm ${plan.featured ? 'text-white/85' : 'text-slate-600'}`}>
                    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${plan.featured ? 'bg-coral/25' : 'bg-coral/10'}`}>
                      <Check className="h-3 w-3 text-coral" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              {PLAN_LINKS[plan.id].paymentLink ? (
                <a
                  href={PLAN_LINKS[plan.id].paymentLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`plan-book-cta-${plan.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`mt-8 inline-flex items-center justify-center rounded-full py-3.5 text-sm font-semibold transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 ${
                    plan.featured
                      ? 'bg-coral text-white hover:bg-coral-deep'
                      : 'border-2 border-navy/15 text-navy hover:border-coral hover:text-coral'
                  }`}
                >
                  Book Now
                </a>
              ) : (
                <PayButton planId={plan.id} planName={plan.name} featured={plan.featured} />
              )}
              <p className={`mt-4 text-center text-[11px] ${plan.featured ? 'text-white/50' : 'text-slate-400'}`}>
                Secure payment via Razorpay
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-center text-sm text-slate-500" data-testid="payment-page-note">
          Prefer to pay directly?{' '}
          <a
            href={PAYMENT_PAGE}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="razorpay-payment-page-link"
            className="font-semibold text-coral transition-colors hover:text-coral-deep"
          >
            Pay via our Razorpay page →
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);

export default Plans;
